export default function HeaderExtension(props) {
  return (
    <div className="flex flex-col flex-wrap mx-auto bg-white text-blue-dark pt-6 sm:pt-4 mt-10 sm:mt-6 w-full  pb-6 ">
      <div className="flex flex-row ">
        <h1 className="flex flex-row text-2xl sm:text-3xl md:text-4xl text-gray-500 mt-16  mx-auto text-center ">
          <span className="  font-bold">{props.title}</span>
        </h1>
      </div>
      {props.buttonComponent ? <div className="flex flex-row justify-center py-4"> {props.buttonComponent}</div> : null}
    </div>
  );
}
